{
  "show_site_header": true,
  "hero": {
    "title": "Looking beyond GDP",
    "subtitle": "Measuring what matters through the High-Level Expert Group's proposed dashboard",
    "image_url": "assets/img/2026-beyond_gdp_hero.jpg",
    "titleHighlight": "beyond GDP"
  },
  "nav": [
    {
      "label": "Data insights",
      "href": ".anchor_data",
      "children": [{ "label": "Current well-being", "href": ".anchor_current_wellbeing" }, { "label": "Equity and inclusion", "href": ".anchor_equity_inclusion" }, { "label": "Sustainability and resilience", "href": ".anchor_sustainability_resilience" }]
    },
    { "label": "Recommendations", "href": ".anchor_gaps" }
  ],
  "download_report_url": "https://unctad.org/system/files/official-document/sddsinf2026d1_en.pdf"
}
